import styled from 'styled-components';

// O painel e mais alto que a tela (cards, graficos e a tabela). Na cadeia de
// altura das listagens o TableWrapper encolhe e so a tabela rola, o que aqui
// cortaria os graficos. `flex-shrink: 0` mantem o card na altura do conteudo,
// e quem rola e o DashboardBodyContent, a pagina inteira.
export const PanelPage = styled.div.attrs({})`
  flex-shrink: 0;
`;

// Seletor de operador, ao lado das datas do PeriodFilter. O Select compartilhado
// tem 48px fixos (ignora o `small`) e, por causa do InputLabel, o MUI empurra o
// campo 16px para baixo. Aqui ele fica com a altura e o alinhamento dos campos
// de data (40px), sem mexer no Select usado pelos formularios.
export const OperatorField = styled.div.attrs({})`
  width: 220px;

  .MuiFormControl-root .MuiInputBase-root {
    margin-top: 0;
    height: 40px;
    font-size: 14px;
  }
`;
